import React, { Component } from 'react'

export class ExploreFilterCheckbox extends Component {

    onChange(type) {
        if (type === "body") {

        }
        else if (type === "gadget") {

        }

    }

    render(props) {
        return (
            <div className="explore-filter">
                <input onChange={(e) => {
                    
                    this.props.handleFilterChange(this.props.type, this.props.filterName,e.target.checked)
                }} type="checkbox" name="" className="explore-filter-checkbox" />
                <span className="explore-filter-span">{this.props.filterName}</span>
            </div>
        )
    }
}

export default ExploreFilterCheckbox
